import { createI18n } from 'vue-i18n'
import zhCN1 from 'vxe-table/lib/locale/lang/zh-CN'//vxe-table的国际化
import enUS1 from 'vxe-table/lib/locale/lang/en-US'
import zhCN from './zh-cn'
import enUS from './en'

// 创建 i18n
const i18n = createI18n({
  locale: 'zhCN',
  messages: {
    zhCN:{
      ...zhCN1,
      ...zhCN,//以项目的国际化为准
    },
    enUS:{
      ...enUS1,
      ...enUS
    }
  }
})

const lang = i18n.global.t
export {
  lang,
  i18n
}
// export default i18n
